module.exports = __webpack_public_path__ + "static/media/cha2.c8f6fa1d.wav";